import { Controller } from "@hotwired/stimulus";
import WordCloud from "wordcloud";

const COLORS = [
  "#6366F1",
  "#F59E0B",
  "#10B981",
  "#EC4899",
  "#14B8A6",
  "#9146FF",
  "#FF0050",
  "#0085FF",
];

function wordColor(word) {
  let h = 0;
  for (let i = 0; i < word.length; i++) h = (h * 31 + word.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

export default class extends Controller {
  static values = { words: Array };

  connect() {
    const words = this.wordsValue;
    if (!words?.length) return;

    const values = words.map((w) => +w.value);
    const minV = Math.min(...values);
    const maxV = Math.max(...values);
    // A degenerate range means every word is equally important, so every word
    // gets the middle of the 5..55 scale. Substituting 1 for the range -- the
    // old guard -- divided safely but left the numerator (+v - minV) at 0, so
    // every word came out at 5px on a 960x600 canvas: a legible cloud and an
    // illegible one look identical from here (StreamCommand-brjm).
    const flat = maxV === minV;
    const scale = (v) => (flat ? 30 : Math.round(5 + ((+v - minV) / (maxV - minV)) * 50));

    const canvas = this.element.querySelector("canvas");
    if (!canvas) return;

    WordCloud(canvas, {
      list: words.map((w) => [w.key, scale(w.value)]),
      fontFamily: "sans-serif",
      color: (word) => wordColor(word),
      rotateRatio: 0.15,
      rotationSteps: 2,
      backgroundColor: "transparent",
      shrinkToFit: true,
    });
  }

  disconnect() {
    const canvas = this.element.querySelector("canvas");
    canvas?.getContext("2d")?.clearRect(0, 0, canvas.width, canvas.height);
  }
}
